import React from 'react';

const AccountV3 = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8 8C9.79493 8 11.25 6.54493 11.25 4.75C11.25 2.95507 9.79493 1.5 8 1.5C6.20507 1.5 4.75 2.95507 4.75 4.75C4.75 6.54493 6.20507 8 8 8Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.0003 9.625C4.7438 9.625 2.0918 11.809 2.0918 14.5C2.0918 14.682 2.2348 14.825 2.4168 14.825H13.5838C13.7658 14.825 13.9088 14.682 13.9088 14.5C13.9088 11.809 11.2568 9.625 8.0003 9.625Z",
      fill: "white"
    }
  )
);

export { AccountV3 };
//# sourceMappingURL=AccountV3.js.map
